import "chartjs-adapter-date-fns";
import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    TimeScale,
} from "chart.js";

Chart.register(TimeScale, LinearScale, LineController, PointElement, LineElement, BarController, CategoryScale, BarElement);

export const MS_IN_DAY = 24 * 3600 * 1000;

export const enum WeekDay {
    Sun = 0,
    Mon,
    Tue,
    Wed,
    Thu,
    Fri,
    Sat,
}

export const enum DateSetMode {
    NoChange = 0,
    StartOfDay,
    EndOfDay,
}

/**
 * Set date forward to given weekday.
 * @param date The date to change.
 * @param weekDay The weekday to move forward to.
 * @param mode Whether to set time to start ord end of the day.
 */
export function setDateToNextWeekday(date: Date, weekDay: WeekDay, mode = DateSetMode.NoChange): Date {
    date.setDate(date.getDate() + ((weekDay + (7 - date.getDay())) % 7));
    if (mode != DateSetMode.NoChange) {
        date.setHours(mode == DateSetMode.StartOfDay ? 0 : 23);
        date.setMinutes(mode == DateSetMode.StartOfDay ? 0 : 59);
        date.setSeconds(mode == DateSetMode.StartOfDay ? 0 : 59);
        date.setMilliseconds(mode == DateSetMode.StartOfDay ? 0 : 999);
    }
    return date;
}
